import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import localeEnAu from '@angular/common/locales/en-AU';
import localeEnGb from '@angular/common/locales/en-GB';
import localeEs from '@angular/common/locales/es';
import localeFr from '@angular/common/locales/fr';
import localeFrCa from '@angular/common/locales/fr-CA';
import { Language } from '@por/shared/core';

/**
 * Angular bundles English locale data only. `LOCALE_ID` is resolved from the
 * `content-lang` value the language selector writes to localStorage, so any
 * `Language` member can reach `DatePipe` / `CurrencyPipe` — and every
 * non-English one throws NG0701 until its data is registered here.
 *
 * Keyed by `Language` so the map is exhaustive by type: a new enum member
 * fails the build until its locale data is supplied.
 */
const supportedLocaleData: Record<Language, unknown> = {
    [Language.DE_DE]: localeDe,
    [Language.EN_AU]: localeEnAu,
    [Language.EN_GB]: localeEnGb,
    [Language.EN_US]: localeEn,
    [Language.ES_ES]: localeEs,
    [Language.FR_CA]: localeFrCa,
    [Language.FR_FR]: localeFr
};

/**
 * Registers locale data for every supported language, under the exact locale id
 * `LOCALE_ID` can hold — rather than relying on Angular's parent-language
 * fallback (`fr-FR` -> `fr`).
 *
 * Called at module load by `CustomerPortalUiModule` and
 * `CustomerPortalAdminUiModule`; safe to call more than once.
 */
export function registerSupportedLocales(): void {
    Object.entries(supportedLocaleData).forEach(([locale, data]) => {
        registerLocaleData(data, locale);
    });
}
